<div class="activity-trail-panel" data-testid="activity-trail">
  <div class="activity-trail-header">
    <span class="activity-trail-header-label">{{ title }}</span>
  </div>

  @if (loading) {
    <div class="activity-trail-placeholder">Nalaganje ...</div>
  } @else if (groups.length === 0) {
    <div class="activity-trail-placeholder">Ni zabeleženih sprememb.</div>
  } @else {
    <div class="activity-trail-list">
      @for (group of visibleGroups; track group.batchId; let i = $index) {
        @if (group.entries.length === 1) {
          <div class="activity-trail-item" [style.animation-delay.ms]="i * 35">
            <ng-container *ngTemplateOutlet="entryTpl; context: { $implicit: group.entries[0] }"></ng-container>
          </div>
        } @else {
          <div class="activity-trail-item activity-trail-group" [style.animation-delay.ms]="i * 35">
            <span class="activity-trail-icon activity-trail-icon--Grouped">
              <span class="material-symbols-outlined">stacks</span>
            </span>
            <div class="activity-trail-content">
              <button type="button" class="activity-trail-group-summary" (click)="toggleGroup(group)" [attr.aria-expanded]="group.expanded">
                <div class="activity-trail-row">
                  <span class="activity-trail-label">{{ changeCountLabel(group.entries.length) }}</span>
                  <span class="activity-trail-group-meta-inline">
                    <span class="activity-trail-time">{{ formatTime(group.entries[0].OccurredAt) }}</span>
                    <span class="material-symbols-outlined activity-trail-group-chevron">{{ group.expanded ? 'expand_less' : 'expand_more' }}</span>
                  </span>
                </div>
                <div class="activity-trail-meta">{{ formatDate(group.entries[0].OccurredAt) }} &middot; {{ group.entries[0].ModifiedByUserFullName }}</div>
              </button>
              @if (group.expanded) {
                <div class="activity-trail-group-details">
                  @for (entry of group.entries; track entry.Id) {
                    <div class="activity-trail-group-entry">
                      <ng-container *ngTemplateOutlet="entryTpl; context: { $implicit: entry, nested: true }"></ng-container>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
      }
      @if (hiddenCount > 0) {
        <button type="button" class="activity-trail-toggle" (click)="toggleExpanded()">
          {{ expanded ? 'Prikaži manj' : 'Prikaži še ' + hiddenCount }}
          <span class="material-symbols-outlined">{{ expanded ? 'expand_less' : 'expand_more' }}</span>
        </button>
      }
    </div>
  }
</div>

<ng-template #entryTpl let-entry let-nested="nested">
  @if (!nested) {
    <span class="activity-trail-icon activity-trail-icon--{{visualType(entry)}}">
      <span class="material-symbols-outlined">{{ iconFor(visualType(entry)) }}</span>
    </span>
  }
  <div class="activity-trail-content" [class.activity-trail-content--nested]="nested">
    <div class="activity-trail-row">
      <span class="activity-trail-label">{{ entry.Label }}</span>
      @if (!nested) {
        <span class="activity-trail-time">{{ formatTime(entry.OccurredAt) }}</span>
      }
    </div>
    @if (entry.NewValueDisplay || entry.OldValueDisplay) {
      <div class="activity-trail-values">
        @if (entry.OldValueDisplay && entry.NewValueDisplay) {
          <span class="old">{{ entry.OldValueDisplay }}</span> &rarr; <span class="new">{{ entry.NewValueDisplay }}</span>
        } @else {
          <span class="new">{{ entry.NewValueDisplay || entry.OldValueDisplay }}</span>
        }
      </div>
    }
    @if (!nested) {
      <div class="activity-trail-meta">{{ formatDate(entry.OccurredAt) }} &middot; {{ entry.ModifiedByUserFullName }}</div>
    }
  </div>
</ng-template>
